'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';

class ContextMenuItem extends ImmutableModel {
  constructor(props) {
    return super(props);
  }

}

ContextMenuItem.REQUIRED_FIELDS = ['label', 'callback'];
ContextMenuItem.DEFAULT_FIELDS = {
  disabled: false,
  isFileUpload: false,
  divider: false
};
export default ContextMenuItem;